import * as React from 'react'
import { Button, CardBody, Input, Label } from 'reactstrap'
import { VCSpinner } from '../shared/spinner'

const { I18n } = window as any

interface TwoFactorVerifyViewProps {
  loading: boolean
  qrCodeUrl: string
  otpSecret: string
  onVerify: (otpCode: string) => void
}

function TwoFactorVerifyView({ loading, qrCodeUrl, otpSecret, onVerify }: TwoFactorVerifyViewProps): JSX.Element {
  const [otpCode, setOtpCode] = React.useState<string>('')
  const [copied, setCopied] = React.useState<boolean>(false)

  const handleOtpCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtpCode(e.target.value)
  }

  const handleVerifyClick = () => {
    onVerify(otpCode)
  }

  const handleCopySecret = () => {
    navigator.clipboard.writeText(otpSecret)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <CardBody>
      <p>{I18n.t('users.two_factor.setup_instructions')}</p>

      <div className="two-factor-setup-qr-section">
        <p>{I18n.t('users.two_factor.scan_qr_code')}</p>

        <div className="d-flex flex-wrap">
          {qrCodeUrl && (
            <div className="two-factor-qr-code">
              <img src={qrCodeUrl} alt="QR Code" />
            </div>
          )}
          <div className="ml-4 mt-4">
            <p>{I18n.t('users.two_factor.manual_entry')}</p>
            <div className="input-group">
              <Input
                type="text"
                value={otpSecret}
                readOnly
                className="form-control two-factor-secret"
                style={{ fontFamily: 'monospace' }}
              />
              <div className="input-group-append">
                <Button
                  color="outline-secondary"
                  onClick={handleCopySecret}
                  title={I18n.t('users.two_factor.copy_to_clipboard')}
                >
                  {copied && <i className="fas fa-check mr-1" />}
                  {!copied && <i className="fas fa-clipboard mr-1" />}
                  {I18n.t('users.two_factor.copy_to_clipboard')}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 mb-4">
          <Label className="mr-3" for="otpCode">
            {I18n.t('users.two_factor.enter_code')}
          </Label>
          <Input
            className="w-auto"
            type="text"
            id="otpCode"
            value={otpCode}
            onChange={handleOtpCodeChange}
            placeholder={I18n.t('users.two_factor.code_placeholder')}
            disabled={loading}
          />
        </div>

        <Button color="primary" onClick={handleVerifyClick} disabled={!otpCode || loading} className="mt-2">
          {loading ? (
            <VCSpinner visible={loading} viewType="inline" size="1" />
          ) : (
            I18n.t('users.two_factor.verify_button')
          )}
        </Button>
      </div>
    </CardBody>
  )
}

export default TwoFactorVerifyView
